<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-03-12 14:02:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>任务管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageTabAdd">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-page-header
              @back="goBack"
              :content="categoryId == '' ? '投诉处理' : '投诉详情'"
            >
            </el-page-header>
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="投诉编号" prop="name">
              <el-input
                disabled
                v-model="ruleForm.No"
                placeholder="投诉编号"
              ></el-input>
            </el-form-item>
            <el-form-item label="任务名称" prop="name">
              <el-input
                disabled
                v-model="ruleForm.name"
                placeholder="任务名称"
              ></el-input>
              <router-link
                target="_blank"
                :to="{ path: '/taskDetail', query: { id: detail.jobId } }"
                class="seeJob"
                >查看任务</router-link
              >
            </el-form-item>
            <el-form-item label="处理状态" prop="complainantName">
              <el-input
                v-if="detail.status == 0"
                disabled
                placeholder="投诉中"
              ></el-input>
              <el-input
                v-if="detail.status == 1"
                disabled
                placeholder="已处理"
              ></el-input>
              <el-input
                v-if="detail.status == 2"
                disabled
                placeholder="已撤销"
              ></el-input>
            </el-form-item>
            <el-form-item label="投诉人" prop="complainantName">
              <el-input
                disabled
                v-model="ruleForm.complainantName"
                placeholder="投诉人"
              ></el-input>
            </el-form-item>
            <el-form-item label="被投诉人" prop="respondentName">
              <el-input
                disabled
                v-model="ruleForm.respondentName"
                placeholder="被投诉人"
              ></el-input>
              <router-link
                class="seeJob"
                target="_blank"
                :to="{ path: '/taskDetail', query: { id: detail.jobId } }"
                >查看考勤</router-link
              >
            </el-form-item>
            <el-form-item label="被投诉人所属" prop="bodyguardType">
              <el-input
                disabled
                v-model="ruleForm.bodyguardType"
                placeholder="被投诉人所属"
              ></el-input>
            </el-form-item>
            <el-form-item label="投诉内容" prop="complainMemo">
              <el-input
                disabled
                v-model="ruleForm.complainMemo"
                placeholder="投诉内容"
              ></el-input>
            </el-form-item>
            <el-form-item label="投诉时间" prop="submitAt">
              <el-input
                disabled
                v-model="ruleForm.submitAt"
                placeholder="投诉时间"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="保安金额"
              prop="bodyguardMoney"
              v-if="isDetail"
            >
              <el-input
                disabled
                v-model="detail.bodyguardMoney"
                placeholder="保安金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="赔偿金额" v-if="isDetail">
              <el-input
                disabled
                v-model="detail.amendsMoney"
                placeholder="赔偿金额"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="用户补偿金额"
              v-if="isDetail && detail.userCompensateMoney != 0"
            >
              <el-input
                disabled
                v-model="detail.userCompensateMoney"
                placeholder="用户补偿金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="责任人" v-if="isDetail">
              <el-input
                disabled
                v-model="detail.dutyName"
                placeholder="责任人"
              ></el-input>
            </el-form-item>
            <el-form-item label="处理备注" v-if="isDetail">
              <el-input
                disabled
                v-model="detail.memo"
                placeholder="处理备注"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="责任人"
              prop="dutyId"
              style="display: flex; align-items: center"
              v-if="!isDetail"
            >
              <el-select
                v-model="ruleForm.dutyId"
                placeholder="请选择"
                :disabled="isDetail"
                @change="selectChange"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  v-for="(item, index) in list"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="赔偿金额" prop="amendsMoney" v-if="!isDetail">
              <el-input
                :disabled="isDetail"
                v-model="ruleForm.amendsMoney"
                placeholder="请输入赔偿金额"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="替换"
              prop="radio"
              v-if="ruleForm.dutyType == 2 && !isDetail"
            >
              <template>
                <el-radio-group
                  v-model="ruleForm.radio"
                  @input="select"
                  :disabled="isDetail"
                >
                  <el-radio v-model="ruleForm.radio" label="0"
                    >无需退换</el-radio
                  >
                  <el-radio v-model="ruleForm.radio" label="1">需退换</el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item label="处理备注" prop="memo" v-if="!isDetail">
              <el-input
                type="textarea"
                :rows="2"
                :disabled="isDetail"
                v-model="ruleForm.memo"
                placeholder="请输入处理备注"
              ></el-input>
            </el-form-item>
            <el-form-item label="保安费用" v-if="ruleForm.dutyType == 1">
              <el-input
                :disabled="isDetail"
                v-model="ruleForm.money"
                placeholder="请输入保安费用"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="用户补偿"
              prop="money1"
              v-if="ruleForm.dutyType != 1"
            >
              <el-input
                :disabled="isDetail"
                v-model="ruleForm.money1"
                placeholder="请输入用户补偿"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="替补人员"
              prop="edit"
              style="display: flex; align-items: center"
              v-if="ruleForm.radio == 1 && ruleForm.dutyType != 1"
            >
              <el-select
                v-model="ruleForm.edit"
                placeholder="请选择"
                :disabled="isDetail"
              >
                <el-option
                  :label="item.cardName || item.companyName"
                  :value="item.id"
                  v-for="(item, index) in list1"
                  :key="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="变更备注"
              prop="editMemo"
              v-if="ruleForm.radio == 1 && ruleForm.dutyType != 1"
            >
              <el-input
                type="textarea"
                :rows="2"
                :disabled="isDetail"
                v-model="ruleForm.editMemo"
                placeholder="请输入变更备注"
              ></el-input>
            </el-form-item>
            <el-form-item v-if="!isDetail">
              <el-button @click="close()">取消</el-button>
              <el-button
                @click="submitForm('ruleForm')"
                class="btn"
                style="margin-right: auto"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.taskData(),
      detail: {},
      ruleForm: {
        name: "",
        dutyType: "",
        respondentName: "",
        bodyguardType: "",
        complainMemo: "",
        complainantName: "",
        submitAt: "",
        memo: "",
        amendsMoney: "",
        dutyId: "",
        radio: "0",
        money: "0",
        money1: "",
        edit: "",
        editMemo: "",
        No: "",
      },
      rules: {
        memo: [{ required: true, message: "必填项", trigger: "blur" }],
        amendsMoney: [{ required: true, message: "必填项", trigger: "blur" }],
        dutyType: [{ required: true, message: "必填项", trigger: "blur" }],
        // money: [{ required: true, message: "必填项", trigger: "blur" }]
      },
      categoryId: "",
      list: [],
      list1: [],
      isDetail: false,
    };
  },
  created: function () {
    if (this.$route.query.id) {
      this.categoryId = this.$route.query.id;
      this.getDetail();
    }
    if (this.$route.query.isDetail) {
      this.isDetail = true;
    }
  },
  methods: {
    selectChange(val) {
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].id == val) {
          let value = "";
          if (this.list[i].type == 1) {
            value = 1;
          } else if (this.list[i].type == 3) {
            value = 2;
          } else {
            value = 3;
          }
          this.ruleForm.dutyType = value;
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            amendsMoney: this.ruleForm.amendsMoney,
            dutyType: this.ruleForm.dutyType == 5 ? 4 : this.ruleForm.dutyType,
            dutyId: this.ruleForm.dutyId,
            memo: this.ruleForm.memo,
            bodyguardMoney: this.ruleForm.money == "" ? 0 : this.ruleForm.money,
            userCompensateMoney: this.ruleForm.money1,
            replaceBodyguardId: this.ruleForm.edit,
            replaceMemo: this.ruleForm.editMemo,
            isReplace: this.ruleForm.radio,
            id: this.categoryId,
          };
          this.$axios
            .post(`/admapi/complain/deal`, param)
            .then(({ data }) => {
              this.$message({
                message: "处理成功",
                type: "success",
              });
              this.$router.go(-1);
            })
            .catch()
            .finally();
        } else {
          return false;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    close() {
      this.$router.go(-1);
    },
    getDetail() {
      this.$axios
        .post(`/admapi/complain/get/${this.categoryId}`)
        .then(({ data }) => {
          this.ruleForm.name = data.jobName;
          this.ruleForm.respondentName = data.respondentName;
          this.ruleForm.bodyguardType =
            data.respondentType == 1
              ? "客户"
              : data.respondentType == 3
              ? "保安-临勤"
              : data.respondentType == 4
              ? "保安-公司"
              : "保安-公司员工";
          this.ruleForm.complainMemo = data.complainMemo;
          this.ruleForm.No = data.complainNo;
          this.ruleForm.submitAt = data.submitAt;
          // this.ruleForm.dutyType = data.dutyType;
          // this.ruleForm.dutyId = data.dutyId;
          this.ruleForm.complainantName = data.complainantName;
          this.detail = data;
          if (this.isDetail == true) {
            this.ruleForm.amendsMoney = data.amendsMoney;
            this.ruleForm.radio = JSON.stringify(data.isReplace);
            this.ruleForm.memo = data.memo;
            this.ruleForm.money = data.bodyguardMoney;
            this.ruleForm.money1 = data.userCompensateMoney;
            this.ruleForm.edit = JSON.stringify(data.replaceBodyguardId);
            this.ruleForm.editMemo = data.replaceMemo;
          }
          // this.getlist();
          let key = "";
          let key1 = "";
          if (data.complainantType == 1) {
            key = "(客户)";
          }
          if (data.complainantType == 3) {
            key = "(保安-临勤)";
          }
          if (data.complainantType == 4) {
            key = "(保安-公司)";
          }
          if (data.complainantType == 5) {
            key = "(保安-公司员工)";
          }
          if (data.respondentType == 1) {
            key1 = "(客户)";
          }
          if (data.respondentType == 3) {
            key1 = "(保安-临勤)";
          }
          if (data.respondentType == 4 || data.respondentType == 5) {
            key1 = "(保安-公司)";
          }
          let complainantType = data.complainantType;
          let respondentType = data.respondentType;

          let arr = [
            {
              id: data.complainantId,
              name: data.complainantName + key,
              type: complainantType,
            },
            {
              id:
                data.respondentType == 4 || data.respondentType == 5
                  ? data.leaderId
                  : data.respondentId,
              name: data.respondentName + key1,
              type: respondentType,
            },
          ];
          this.list = arr;
          console.log(arr);
        })
        .catch()
        .finally();
    },
    getlist() {
      this.$axios
        .post(`/admapi/complain/member/${this.categoryId}`)
        .then(({ data }) => {
          this.list = data;
        })
        .catch()
        .finally();
    },
    getlist1() {
      let param = {
        page: 1,
        pageSize: 1000,
        pageNo: 1,
        jobNo: this.detail.jobNo,
      };
      this.$axios
        .post(`admapi/bodyguard/dispathMemberlist`, param)
        .then(({ data }) => {
          this.list1 = data.items;
        })
        .catch()
        .finally();
    },
    select(val) {
      if (val == 1) {
        this.getlist1();
      }
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 750px;
}
.seeJob {
  flex: none;
  margin-left: 20px;
  cursor: pointer;
  color: rgb(78, 78, 222);
  text-decoration: none;
}
.el-form-item {
  display: flex !important;
  align-content: center !important;
}
.el-radio {
  line-height: 40px !important;
}
</style>
